<template>
  <v-textarea
    v-model="localValue"
    :label="label"
    :maxlength="maxLength"
    :counter="maxLength"
    :rules="rules"
    rows="1"
    auto-grow
    @keypress="preventDeniedCharacters($event)"
    :data-cy="cyTag"
    :class="{ 'text-field-required': required }"
  />
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'DeviceAttributeTextarea',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    rules: {
      type: Array as PropType<Array<(v: string) => string | boolean>>,
      default: (): Array<(v: string) => string | boolean> => []
    },
    required: {
      type: Boolean,
      default: false
    },
    cyTag: {
      type: String,
      default: undefined
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      maxLength: 255
    }
  },
  computed: {
    localValue: {
      get(): string {
        return this.modelValue
      },
      set(localValue: string) {
        this.$emit('update:modelValue', localValue)
      }
    }
  },
  methods: {
    preventDeniedCharacters(event: KeyboardEvent) {
      if (event.key === 'Enter') {
        event.preventDefault()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.v-textarea :deep(textarea) {
  line-height: 1.75;
  overflow: hidden;
}
</style>
